import React, { useEffect, useState, useRef, lazy } from 'react';
/* ─── STICKY ANNOUNCEMENT BAR WITH COUNTDOWN ─── */
export function AnnouncementBar() {
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutes in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <>
      <style data-id="element-524">{`
      @keyframes slide-left {
        0% { transform: translateX(100%); }
        100% { transform: translateX(-100%); }
      }
    `}</style>
      <div className="fixed top-0 left-0 right-0 z-[9999] bg-[#2C3E50] text-white text-[11px] sm:text-sm font-bold py-2 sm:py-2.5 w-full overflow-hidden" style={{
      WebkitBackfaceVisibility: 'hidden',
      backfaceVisibility: 'hidden'
    }} data-id="element-525">
        <div className="whitespace-nowrap px-3 sm:px-4" style={{
        animation: 'slide-left 12s linear infinite'
      }} data-id="element-526">
          <span data-id="element-527">⚡ OFERTA FINALIZA EN: </span>
          <span className="font-mono bg-white/10 px-1.5 sm:px-2 py-0.5 rounded text-[#F5C842] font-black tracking-wider" data-id="element-528">
            {formattedTime}
          </span>
          <span className="hidden sm:inline" data-id="element-529">
            {' '}
            — Quedan los últimos 13 Kits a $12.999
          </span>
          <span className="sm:hidden" data-id="element-530"> — Últimos 13 Kits</span>
        </div>
      </div>
    </>;
}
/* ─── NAVBAR ─── */
export function Navbar() {
  const isLP2 = typeof window !== 'undefined' && window.location.pathname.startsWith('/lp2');
  return <nav className="bg-[#FDF9F3] border-b border-gray-100 px-5 sm:px-6 py-3" data-id="element-531">
      <div className="max-w-[680px] mx-auto flex items-center justify-between" data-id="element-532">
        <a href="/" className="text-[#2C3E50] font-black text-[15px] tracking-tight no-underline" data-id="element-533">
          VITALIA guides 🌿
        </a>
      </div>
    </nav>;
}
/* ─── HERO ─── */
export function HeroSection() {
  return <section className="relative overflow-hidden" data-id="element-534">
      <style data-id="element-535">{`
        @keyframes pulse-orange {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.02); }
        }
        .pulse-orange-btn { animation: pulse-orange 2s ease-in-out infinite; }
      `}</style>

      {/* Full-bleed hero image with text overlay */}
      <div className="relative min-h-[520px] sm:min-h-[560px] md:min-h-[500px]" data-id="element-536">
        <img src="https://cdn.magicpatterns.com/uploads/sFyrRUNnf7qpLQBV36fpzC/hero.png" alt="Mamá e hijo disfrutando comida saludable juntos" className="absolute inset-0 w-full h-full object-cover object-top" loading="eager" data-id="element-537" />
        {/* Gradient overlay for text readability */}
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(to bottom, rgba(253,249,243,0.92) 0%, rgba(253,249,243,0.75) 35%, rgba(253,249,243,0.15) 65%, rgba(253,249,243,0) 100%)'
      }} data-id="element-538" />

        {/* Text content overlaid on image */}
        <div className="relative z-10 max-w-[680px] mx-auto px-5 sm:px-6 pt-6 sm:pt-10 pb-8" data-id="element-539">
          <div className="text-center" data-id="element-540">
            <div className="bg-white/90 border-2 border-[#5E8D5A] text-[#2C3E50] text-[11px] font-bold py-1.5 px-3.5 rounded-full inline-block mb-4 shadow-sm backdrop-blur-sm" data-id="element-541">
              🌿 Para niños selectivos de 3 a 12 años
            </div>

            <h1 className="sm:text-[34px] md:text-[40px] mb-4 tracking-tight drop-shadow-[0_1px_2px_rgba(255,255,255,0.8)] text-[20px] text-[#0B5522] pt-[-5px] pb-[-5px] font-[900] font-[Merriweather,_serif]" data-id="element-542">
              Lográ que tu hijo coma verduras hoy mismo sin peleas ni llantos
            </h1>

            <p className="sm:text-[17px] max-w-[480px] mx-auto drop-shadow-[0_1px_1px_rgba(255,255,255,0.6)] text-[#0E1711] pt-[-5px] pb-[-5px] text-[14px] font-[500] font-['Tiro_Gurmukhi',_serif] mt-[8px] mb-[8px]" data-id="element-543">
              El Método 3C: La guía definitiva para mamás de nenes selectivos
              que ya lo intentaron todo.
            </p>
          </div>
        </div>
      </div>

      {/* CTA + trust section below image */}
      <div className="bg-[#FDF9F3] px-5 sm:px-6 pb-8 pt-6 text-center" data-id="element-544">
        <div className="max-w-[420px] mx-auto" data-id="element-545">
          <a href="#order" className="bg-[#E67E22] text-white font-black py-4 px-6 rounded-2xl block w-full transition-all duration-200 hover:bg-[#d67118] hover:-translate-y-0.5 text-[16px] sm:text-[18px] text-center" style={{
          boxShadow: '0 12px 32px rgba(230,126,34,0.35)'
        }} data-id="element-546">
            <span className="pulse-orange-btn inline-block w-full" data-id="element-547">
              SÍ, QUIERO PAZ EN MI MESA →
            </span>
          </a>

          <div className="flex flex-col items-center mt-5 gap-3" data-id="element-548">
            <div className="flex items-center gap-2" data-id="element-549">
              <span className="text-[#F5C842] text-lg" data-id="element-550">⭐⭐⭐⭐⭐</span>
              <span className="font-extrabold text-[#2C3E50] text-sm" data-id="element-551">
                4.9/5
              </span>
              <span className="text-gray-400 text-xs font-medium" data-id="element-552">
                de 1.200+ mamás
              </span>
            </div>
            <p className="text-gray-500 text-[11px] font-semibold flex gap-2.5 flex-wrap justify-center" data-id="element-553">
              <span data-id="element-554">📥 Acceso inmediato</span>
              <span data-id="element-555">🛡️ Garantía 30 días</span>
              <span data-id="element-556">💳 Pago seguro</span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}
/* ─── PAIN SECTION (3 Cuchillazos + Antes/Después) ─── */
export function PainSection() {
  return <section className="bg-[#FDF9F3] py-8 px-5 sm:py-10 sm:px-6 border-t border-gray-100" data-id="element-557">
      <div className="max-w-[600px] mx-auto" data-id="element-558">
        <h2 className="text-[#2C3E50] text-[24px] sm:text-[28px] font-black text-center mb-6 leading-tight tracking-tight" data-id="element-559">
          ¿Te pasa esto?
        </h2>

        {/* 3 Pain Cards */}
        <div className="flex flex-col gap-4 mb-6" data-id="element-560">
          {/* Pain 1 */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.06)] border border-gray-100" data-id="element-561">
            <div className="flex flex-col sm:flex-row" data-id="element-562">
              <img src="https://cdn.magicpatterns.com/uploads/jFTc5e7v5KGXy76Ycr5wHF/platos_al_tacho.png" alt="Plato de comida siendo tirado a la basura" className="w-full sm:w-[140px] h-[180px] sm:h-auto object-cover rounded-[12px] m-3 sm:m-0 sm:rounded-none sm:rounded-l-[12px] shadow-[0_2px_8px_rgba(0,0,0,0.1)] sm:shadow-none flex-shrink-0" loading="lazy" data-id="element-563" />
              <div className="px-5 pb-5 pt-2 sm:py-5 sm:px-5 flex flex-col justify-center" data-id="element-564">
                <h3 className="text-[#2C3E50] text-[16px] sm:text-[17px] font-black mb-1.5" data-id="element-565">
                  Platos al tacho
                </h3>
                <p className="text-[#6B7280] text-[14px] sm:text-[15px] leading-relaxed" data-id="element-566">
                  Cocinás con amor, buscás recetas y terminás tirando comida (y
                  tu paciencia) a la basura.
                </p>
              </div>
            </div>
          </div>

          {/* Pain 2 */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.06)] border border-gray-100" data-id="element-567">
            <div className="flex flex-col sm:flex-row" data-id="element-568">
              <img src="https://cdn.magicpatterns.com/uploads/1PyRWxVJBLt91h3dfrKPg8/cocinera_a_la_carta.png" alt="Mamá agotada cocinando múltiples platos" className="w-full sm:w-[140px] h-[180px] sm:h-auto object-cover rounded-[12px] m-3 sm:m-0 sm:rounded-none sm:rounded-l-[12px] shadow-[0_2px_8px_rgba(0,0,0,0.1)] sm:shadow-none flex-shrink-0" loading="lazy" data-id="element-569" />
              <div className="px-5 pb-5 pt-2 sm:py-5 sm:px-5 flex flex-col justify-center" data-id="element-570">
                <h3 className="text-[#2C3E50] text-[16px] sm:text-[17px] font-black mb-1.5" data-id="element-571">
                  Cocinera a la carta
                </h3>
                <p className="text-[#6B7280] text-[14px] sm:text-[15px] leading-relaxed" data-id="element-572">
                  Agotada de cocinar platos distintos para que el nene coma algo
                  mientras vos comés frío.
                </p>
              </div>
            </div>
          </div>

          {/* Pain 3 */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.06)] border border-gray-100" data-id="element-573">
            <div className="flex flex-col sm:flex-row" data-id="element-574">
              <img src="https://cdn.magicpatterns.com/uploads/kWYJLJLAF3gyfrVMhfcev5/Cenas_bajo_tension.png" alt="Niño rechazando comida en la mesa" className="w-full sm:w-[140px] h-[180px] sm:h-auto object-cover rounded-[12px] m-3 sm:m-0 sm:rounded-none sm:rounded-l-[12px] shadow-[0_2px_8px_rgba(0,0,0,0.1)] sm:shadow-none flex-shrink-0" loading="lazy" data-id="element-575" />
              <div className="px-5 pb-5 pt-2 sm:py-5 sm:px-5 flex flex-col justify-center" data-id="element-576">
                <h3 className="text-[#2C3E50] text-[16px] sm:text-[17px] font-black mb-1.5" data-id="element-577">
                  Cenas bajo tensión
                </h3>
                <p className="text-[#6B7280] text-[14px] sm:text-[15px] leading-relaxed" data-id="element-578">
                  La hora de comer se volvió un campo de batalla de ruegos,
                  llantos y negociaciones infinitas.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Antes/Después Comparison Table */}
        <div className="bg-white rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.04)] overflow-hidden border border-gray-100" data-id="element-579">
          {/* Table Header */}
          <div className="flex border-b border-gray-100" data-id="element-580">
            <div className="flex-1 bg-[#FEF2F2] py-3 px-4 text-center border-r border-gray-100" data-id="element-581">
              <span className="text-[#DC2626] text-[13px] font-black tracking-widest uppercase" data-id="element-582">
                😩 EL CAOS
              </span>
            </div>
            <div className="flex-1 bg-[#F0FDF4] py-3 px-4 text-center" data-id="element-583">
              <span className="text-[#5E8D5A] text-[13px] font-black tracking-widest uppercase" data-id="element-584">
                ✨ CON VITALIA
              </span>
            </div>
          </div>

          {/* Table Rows */}
          <div className="flex flex-col" data-id="element-585">
            {/* Row 1 */}
            <div className="flex border-b border-gray-50" data-id="element-586">
              <div className="flex-1 py-4 px-3 sm:px-5 flex items-center gap-3 border-r border-gray-50" data-id="element-587">
                <span className="text-xl flex-shrink-0 opacity-70" data-id="element-588">🗑️</span>
                <span className="text-[#6B7280] text-[13px] sm:text-[14px] font-semibold leading-snug" data-id="element-589">
                  Tirás comida y paciencia
                </span>
              </div>
              <div className="flex-1 py-4 px-3 sm:px-5 flex items-center gap-3 bg-[#FADFDF]/[0.02]" data-id="element-590">
                <span className="text-xl flex-shrink-0" data-id="element-591">🥦</span>
                <span className="text-[#2C3E50] text-[13px] sm:text-[14px] font-bold leading-snug" data-id="element-592">
                  Vuelve la variedad
                </span>
              </div>
            </div>

            {/* Row 2 */}
            <div className="flex border-b border-gray-50" data-id="element-593">
              <div className="flex-1 py-4 px-3 sm:px-5 flex items-center gap-3 border-r border-gray-50" data-id="element-594">
                <span className="text-xl flex-shrink-0 opacity-70" data-id="element-595">🍳</span>
                <span className="text-[#6B7280] text-[13px] sm:text-[14px] font-semibold leading-snug" data-id="element-596">
                  Cocinás doble cada noche
                </span>
              </div>
              <div className="flex-1 py-4 px-3 sm:px-5 flex items-center gap-3 bg-[#FADFDF]/[0.02]" data-id="element-597">
                <span className="text-xl flex-shrink-0" data-id="element-598">🧘‍♀️</span>
                <span className="text-[#2C3E50] text-[13px] sm:text-[14px] font-bold leading-snug" data-id="element-599">
                  Comés tranquila
                </span>
              </div>
            </div>

            {/* Row 3 */}
            <div className="flex" data-id="element-600">
              <div className="flex-1 py-4 px-3 sm:px-5 flex items-center gap-3 border-r border-gray-50" data-id="element-601">
                <span className="text-xl flex-shrink-0 opacity-70" data-id="element-602">😭</span>
                <span className="text-[#6B7280] text-[13px] sm:text-[14px] font-semibold leading-snug" data-id="element-603">
                  Cenas con estrés y llantos
                </span>
              </div>
              <div className="flex-1 py-4 px-3 sm:px-5 flex items-center gap-3 bg-[#FADFDF]/[0.02]" data-id="element-604">
                <span className="text-xl flex-shrink-0" data-id="element-605">⚡</span>
                <span className="text-[#2C3E50] text-[13px] sm:text-[14px] font-bold leading-snug" data-id="element-606">
                  Resultados desde hoy
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
/* ─── MAMA RESULTS (Social Proof Photos) ─── */
export function MamaResultsSection() {
  const results = [{
    img: 'https://cdn.magicpatterns.com/uploads/sFwZAzajcGbUC7TmuZyMJ5/Gratinado_de_Brocoli.png',
    alt: 'Niño comiendo brócoli gratinado',
    caption: '¡No lo puedo creer! Se comió todo el brócoli sin chistar. Gracias Vitalia! 🙌'
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/fSdQfPKX6yu1CMtfaHP5xF/milanesas_camufladas.png',
    alt: 'Plato casi vacío de milanesas verdes',
    caption: 'Primera noche que no tengo que cocinar doble. Un éxito las milas verdes.'
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/cSHcS7zZ4TP1WefqHJaZQT/muffin_de_verduras.png',
    alt: 'Muffin de verduras casero',
    caption: '¡Merienda aprobada! Por fin una forma de que coma zanahoria sin peleas.'
  }];
  return <section className="bg-[#F0FDF4] py-8 px-5 sm:py-10 sm:px-6" data-id="element-607">
      <div className="max-w-[720px] mx-auto" data-id="element-608">
        <p className="text-[#5E8D5A] text-[11px] sm:text-[12px] font-black tracking-[2px] text-center uppercase mb-1.5" data-id="element-609">
          📸 RESULTADOS REALES
        </p>
        <h2 className="text-[#2C3E50] text-[22px] sm:text-[26px] font-black text-center mb-6 leading-tight tracking-tight" data-id="element-610">
          Lo que logran las mamás en la primera semana
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-611">
          {results.map((item, i) => <div key={i} className="bg-white rounded-[12px] overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.08)]" data-id="element-612">
              {/* Photo */}
              <div className="relative" data-id="element-613">
                <img src={item.img} alt={item.alt} className="w-full h-[220px] sm:h-[240px] object-cover" loading="lazy" data-id="element-614" />
              </div>

              {/* WhatsApp-style speech bubble */}
              <div className="relative px-4 pt-3 pb-4" data-id="element-615">
                {/* Bubble tail */}
                <div className="absolute -top-[8px] left-5 w-0 h-0" style={{
              borderLeft: '8px solid transparent',
              borderRight: '8px solid transparent',
              borderBottom: '8px solid #DCF8C6'
            }} data-id="element-616" />
                <div className="bg-[#DCF8C6] rounded-[10px] rounded-tl-none px-3.5 py-2.5 shadow-[0_1px_3px_rgba(0,0,0,0.08)]" data-id="element-617">
                  <p className="text-[#1B2E1B] text-[13px] sm:text-[14px] leading-snug font-medium" data-id="element-618">
                    {item.caption}
                  </p>
                  <div className="flex items-center justify-end gap-1 mt-1.5" data-id="element-619">
                    <span className="text-[10px] text-[#6B8F6B] font-medium" data-id="element-620">
                      {i === 0 ? '20:14' : i === 1 ? '21:03' : '16:47'}
                    </span>
                    <svg className="w-3.5 h-3.5 text-[#53BDEB]" viewBox="0 0 16 16" fill="currentColor" data-id="element-621">
                      <path d="M15.01 3.316l-.478-.372a.365.365 0 0 0-.51.063L8.666 9.88a.32.32 0 0 1-.484.032l-.358-.325a.32.32 0 0 0-.484.032l-.378.48a.418.418 0 0 0 .036.54l1.32 1.267a.32.32 0 0 0 .484-.034l6.272-8.048a.366.366 0 0 0-.064-.512zm-4.1 0l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.88a.32.32 0 0 1-.484.032L1.892 7.77a.366.366 0 0 0-.516.005l-.423.433a.364.364 0 0 0 .006.514l3.255 3.185a.32.32 0 0 0 .484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z" data-id="element-622" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
/* ─── MECHANISM 3C (Minimalist) ─── */
export function MechanismSection() {
  return <section style={{
    background: 'linear-gradient(145deg, #2C3E50 0%, #1a252f 100%)'
  }} className="py-12 px-5 sm:py-16 sm:px-6" data-id="element-623">
      <div className="max-w-[560px] mx-auto" data-id="element-624">
        <div className="text-center mb-10" data-id="element-625">
          <h2 className="text-white text-[28px] sm:text-[32px] font-black leading-tight mb-2 tracking-tight" data-id="element-626">
            El Método 3C
          </h2>
          <p className="text-[#5E8D5A] text-[16px] sm:text-[18px] font-bold tracking-wide" data-id="element-627">
            3 técnicas. 250 recetas. Cero peleas.
          </p>
        </div>

        <div className="flex flex-col gap-4" data-id="element-628">
          {/* Card 1 */}
          <div className="bg-white/5 border border-white/10 rounded-2xl p-5 flex gap-4 items-start backdrop-blur-sm" data-id="element-629">
            <div className="bg-[#5E8D5A]/20 text-[#5E8D5A] w-12 h-12 rounded-xl flex items-center justify-center text-2xl flex-shrink-0" data-id="element-630">
              🎨
            </div>
            <div data-id="element-631">
              <h3 className="text-[#5E8D5A] text-[18px] font-black mb-1.5 uppercase tracking-wide" data-id="element-632">
                COLOR
              </h3>
              <p className="text-white/80 text-[15px] leading-relaxed font-medium" data-id="element-633">
                Hackeo visual para que el plato sea irresistible.
              </p>
            </div>
          </div>

          {/* Card 2 */}
          <div className="bg-white/5 border border-white/10 rounded-2xl p-5 flex gap-4 items-start backdrop-blur-sm" data-id="element-634">
            <div className="bg-[#F5C842]/20 text-[#F5C842] w-12 h-12 rounded-xl flex items-center justify-center text-2xl flex-shrink-0" data-id="element-635">
              🥄
            </div>
            <div data-id="element-636">
              <h3 className="text-[#F5C842] text-[18px] font-black mb-1.5 uppercase tracking-wide" data-id="element-637">
                CONSISTENCIA
              </h3>
              <p className="text-white/80 text-[15px] leading-relaxed font-medium" data-id="element-638">
                Cómo introducir texturas conflictivas sin rechazo.
              </p>
            </div>
          </div>

          {/* Card 3 */}
          <div className="bg-white/5 border border-white/10 rounded-2xl p-5 flex gap-4 items-start backdrop-blur-sm" data-id="element-639">
            <div className="bg-[#E67E22]/20 text-[#E67E22] w-12 h-12 rounded-xl flex items-center justify-center text-2xl flex-shrink-0" data-id="element-640">
              🧘
            </div>
            <div data-id="element-641">
              <h3 className="text-[#E67E22] text-[18px] font-black mb-1.5 uppercase tracking-wide" data-id="element-642">
                CALMA
              </h3>
              <p className="text-white/80 text-[15px] leading-relaxed font-medium" data-id="element-643">
                Técnicas para que TU estrés no bloquee su apetito.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}